export default {
  AU_COPYRIGHT: 'Copyright @ 2015-2021',
  AU_DFOCUS: 'DFocus | YunShen Information Technology (Shanghai) Co.,Ltd',
  AU_COMPANY_WEBSITE: 'Company website',
  AU_ABOUT_US: 'About us',
  ABOUT_US_SEETING: 'About page',
  LOGIN_PAGE_SEETING: 'Login page'
}
